module.exports = __webpack_public_path__ + "img/70.af00b502.jpg";